export const drawerEvent = {
  listen: ({ eventName, onEvent }) => {
    if (!document) {
      // eslint-disable-next-line no-console
      console.error('document was not found, unable to setup listeners for drawer listener');
      return;
    }
    document.addEventListener(eventName, onEvent);
  }
};